module.exports = __webpack_public_path__ + "static/media/physics.94b6a68f.jpg";